import Ekskul from '../../../views/Student/ekskul/Ekskul.student.view';

export default Ekskul; 